/**
 *
 *
 */

import RiskFactor from './risk-factor';

export default class IsHosting extends RiskFactor {
    icon = 'close-s';

    className = 'icon-red';

    label = 'Order Placed From';

    result = 'Hosting';

    static getCondition({isHosting}) {
        return !!isHosting;
    }

    parse({isHosting}) {
        this.isHosting = isHosting;
    }

    getResult() {
        return this.result;
    }
}
